import React from 'react';

const DataSourceDisplay = ({ source, position }) => {
  if (!position) return null;

  const displaySource = source?.toLowerCase() === 'manual_input' 
    ? 'Manual input' 
    : source?.toLowerCase() === 'prioryear' 
      ? 'Guidant records' 
      : (source || 'N/A');

  return (
    <div 
      className="data-source-floating-display"
      style={{
        position: 'fixed',
        top: `${position.y}px`,
        left: `${position.x}px`,
      }}
    >
      Source: {displaySource}
    </div>
  );
};

export default DataSourceDisplay;